import React, { useState } from 'react';
import styled from 'styled-components';
import { pxToRem } from '../../../../styles/utils';
import { up } from 'styled-breakpoints';
import * as constants from '../../../../constants/investTransactPage';
import { dropDownStyling} from '../../../../styles/common';
import { Tooltip, P2, P3, Row, Col, B1, CheckBox, SelectDropdown, Input } from 'pfm-ui-components';
import InfoIcon from '../../../../assets/icons/info-hover.svg';
import { formatValueForDropDown, convertArrayOfStringsToDropDownOptionsFormatWithSecondaryLabel } from './util';
import { useFormik } from 'formik';
import {
  INVESTMENT_TIME_FRAME_MAPPING_FOR_DROPDOWN,
  INVESTMENT_TIME_FRAME_MAPPING,
} from '../../../../constants/common';
import { BuyDetailsProps } from '../../../../pages/transact/invest';
import ChevronRightWhite from '../../../../assets/icons/chevron-right-white.svg'
import ChevronRightPrimary from '../../../../assets/icons/chevron-right.svg'
import { useDeviceType } from '../../../../utils/deviceType';
import DEVICE_TYPE from '../../../../constants/device';
import ChevronRightBlack from '../../../../assets/icons/disclaimer-right-arrow.svg';

interface OtherDetailsCardProps {
  formik: any;
  onChange: Function;
  buyDetails: BuyDetailsProps;
  hideChevron?: boolean;
  enableArrowForLargeScreen?: boolean;
  isOpen: boolean;
  setIsOpen?: Function;

}

const InvestmentTimeFrameRef = React.createRef();
export default function OtherDetailsCard (props: OtherDetailsCardProps){
  const {
    formik,
    onChange,
    buyDetails,
    enableArrowForLargeScreen,
  } = props;
  const isMobile = useDeviceType() === DEVICE_TYPE.MOBILE;
  const [isOpen, setOpen] = useState(true);
  const toggleOpen = () => {
    setOpen(!isOpen);
  };

  return (
<>
      <DetailsCard>
      {isMobile ? (
     <>
      <OtherInvestmentDetailsMobile isOpen={isOpen}>
        <Heading>{constants.OTHER_INVESTMENT_DETAIL}
            <ChevronWrapperMobile onClick={toggleOpen}>
            {isOpen ? (
                <ChevronRightBlackStyled $isOpen={isOpen}  />
              ) : (
                <ChevronRightBlackStyled $isOpen={isOpen} $enable={enableArrowForLargeScreen} />
              )}
</ChevronWrapperMobile>
        </Heading>
      </OtherInvestmentDetailsMobile>
      {isOpen &&(
       <OtherDetailsPageCardMobile>
      <SelectDropDownWrapperMobile>
        <SelectDropdownLabelMobile>{constants.INVESTMENT_TIME_FRAME}</SelectDropdownLabelMobile>
        <SelectDropdownContainerMobile>
          <SelectDropdown
            className="dropdown-v2"
            placeholder="Enter here"
            dropdownStyling={dropDownStyling}
            shouldShowAsterisk={false}
            rotateDropdownIcon={true}
            // secondaryPlaceholder="In Years"
            options={constants.TIME_FRAME}
            onChange={(data) => onChange('investmentTimeframe', data?.value)}
            value={formik?.values?.investmentTimeframe ? formatValueForDropDown(formik?.values?.investmentTimeframe) : formatValueForDropDown(INVESTMENT_TIME_FRAME_MAPPING_FOR_DROPDOWN[buyDetails?.maximumTimeHorizon])}
            // value={
            //   formik.values.investmentTimeframe && formatValueForDropDown(formik.values.investmentTimeframe)
            // }
            innerRef={InvestmentTimeFrameRef}
            onBlur={formik?.handleBlur}
            error={formik?.touched?.investmentTimeframe && formik?.errors?.investmentTimeframe}
            errorMsg={formik?.errors?.investmentTimeframe}
          />
        </SelectDropdownContainerMobile>

        <TooltipWrapper>
          <Tooltip
            content={
              <div>
                <TooltipHeading>{constants.INVESTMENT_TIME_FRAME}</TooltipHeading>

                <TooltipSubHeading>{constants.INVESTMENT_TIME_FRAME_TOOLTIP_MESSAGE}</TooltipSubHeading>
              </div>
            }
            className="tooltipStyle"
          >
            <ToolTipIconMobile>
              <InfoIcon />
            </ToolTipIconMobile>
          </Tooltip>
        </TooltipWrapper>
      </SelectDropDownWrapperMobile>
    </OtherDetailsPageCardMobile>)}
    
    </>
    
      ):(
       <>
        <OtherInvestmentDetails isOpen={isOpen}>
          <Heading>{constants.OTHER_INVESTMENT_DETAIL}
          <ChevronWrapper onClick={toggleOpen}>
            {isOpen ? (
                <ChevronRightBlackStyled $isOpen={isOpen}  />
              ) : (
                <ChevronRightBlackStyled $isOpen={isOpen} $enable={enableArrowForLargeScreen} />
              )}
            </ChevronWrapper>
           </Heading>
        </OtherInvestmentDetails>
        {isOpen && (
         <OtherDetailsPageCard>
        <SelectDropDownWrapper>
          <SelectDropdownLabel>{constants.INVESTMENT_TIME_FRAME}</SelectDropdownLabel>
          <SelectDropdownContainer>
            <SelectDropdown
              className="dropdown-v2"
              placeholder="Enter here"
              dropdownStyling={dropDownStyling}
              shouldShowAsterisk={false}
              rotateDropdownIcon={true}
              // secondaryPlaceholder="In Years"
              options={constants.TIME_FRAME}
              onChange={(data) => onChange('investmentTimeframe', data.value)}
              value={formik?.values?.investmentTimeframe ? formatValueForDropDown(formik?.values?.investmentTimeframe) : formatValueForDropDown(INVESTMENT_TIME_FRAME_MAPPING_FOR_DROPDOWN[buyDetails?.maximumTimeHorizon])}
              // value={
              //   formik.values.investmentTimeframe && formatValueForDropDown(formik.values.investmentTimeframe)
              // }
              innerRef={InvestmentTimeFrameRef}
              onBlur={formik?.handleBlur}
              error={formik?.touched?.investmentTimeframe && formik?.errors?.investmentTimeframe}
              errorMsg={formik?.errors?.investmentTimeframe}
            />
          </SelectDropdownContainer>
  
          <TooltipWrapper>
            <Tooltip
              content={
                <div>
                  <TooltipHeading>{constants.INVESTMENT_TIME_FRAME}</TooltipHeading>
  
                  <TooltipSubHeading>{constants.INVESTMENT_TIME_FRAME_TOOLTIP_MESSAGE}</TooltipSubHeading>
                </div>
              }
              className="tooltipStyle"
            >
              <ToolTipIcon>
                <InfoIcon />
              </ToolTipIcon>
            </Tooltip>
          </TooltipWrapper>
        </SelectDropDownWrapper>
      
      </OtherDetailsPageCard>
        )}
      </>
      )}
    </DetailsCard>
    </>
  );
};

const DetailsCard = styled.div`
margin-top: 1rem;
;`

const OtherDetailsPageCard = styled.div`
background-color: #ffffff;
border-radius: ${pxToRem(8)} : ${pxToRem(8)} ${pxToRem(8)} 0 0 ;
//box-shadow : 0 ${pxToRem(2)} ${pxToRem(8)} #00000029 : none;
box-shadow : 0 ${pxToRem(2)} ${pxToRem(8)} #00000029 : 0;
margin-bottom:  ${pxToRem(16)};
height: 6.75rem;
//margin-top:  ${pxToRem(20)};
${up('md')} {
  border-radius: 0 0 ${pxToRem(8)} ${pxToRem(8)} ;
  box-shadow: 0 ${pxToRem(2)} ${pxToRem(8)} #00000029 ;
  margin-bottom:  ${pxToRem(24)} : 0;
}
`;

const OtherDetailsPageCardMobile = styled.div`
background-color: #ffffff;
border-radius: 0 0 ${pxToRem(8)} ${pxToRem(8)};
//box-shadow : 0 ${pxToRem(2)} ${pxToRem(8)} #00000029 : none;
box-shadow : 0 ${pxToRem(2)} ${pxToRem(8)} #00000029 ;
margin-bottom:  ${pxToRem(16)};
height:6.5rem;
//margin-top:  ${pxToRem(20)};
${up('md')} {
  border-radius: 0 0 ${pxToRem(8)} ${pxToRem(8)} ;
  box-shadow: 0 ${pxToRem(2)} ${pxToRem(8)} #00000029 ;
  margin-bottom:  ${pxToRem(24)} : 0;
}

`;

const OtherInvestmentDetails = styled.div<{ isOpen?: boolean }>` 
background-color:#ECECEC;
position: relative;
border-radius: ${pxToRem(8)} : ${pxToRem(8)} ${pxToRem(8)} 0 0 ;
//box-shadow : 0 ${pxToRem(2)} ${pxToRem(8)} #00000029 : none;
//box-shadow : 0 ${pxToRem(2)} ${pxToRem(8)} #00000029 : 0;
//margin-bottom:  ${pxToRem(16)};
height:${pxToRem(40)};
//margin-top:  ${pxToRem(20)};
${up('md')} {
  border-radius:${props => (props.isOpen ? '8px 8px 0px 0px' : '8px')};
  //box-shadow: 0 ${pxToRem(2)} ${pxToRem(8)} #00000029 ;
  //margin-top:  ${pxToRem(24)} : 10px;
}
`;

const OtherInvestmentDetailsMobile = styled.div<{ isOpen?: boolean }>` 
background-color:#ECECEC;
position: relative;
border-radius:${props => (props.isOpen ? '8px 8px 0px 0px' : '8px')};
//box-shadow : 0 ${pxToRem(2)} ${pxToRem(8)} #00000029 : none;
//box-shadow : 0 ${pxToRem(2)} ${pxToRem(8)} #00000029 : 0;
//margin-bottom:  ${pxToRem(16)};
height:${pxToRem(40)};
//margin-top:  ${pxToRem(20)};
${up('md')} {
  border-radius:${props => (props.isOpen ? '8px 8px 0px 0px' : '8px')};
  //box-shadow: 0 ${pxToRem(2)} ${pxToRem(8)} #00000029 ;
  //margin-top:  ${pxToRem(24)} : 10px;
}
`;

const Heading = styled.div`
  position: relative;
  margin-left: 25px;
  padding-top: 11px;
`;

const SelectDropDownWrapper = styled.article<{ reduceWidth?: boolean; addLeftMargin?: boolean }>`
  position: relative;
  margin-left: ${(props) => (props.addLeftMargin ? `${pxToRem(16)}` : '0')};
  max-width: ${(props) => (props.reduceWidth ? `90%` : 'auto')};
  margin-bottom: ${pxToRem(12)};
  ${up('md')} {
    margin-left: 0;
    max-width: ${pxToRem(320)};
    padding-right: ${pxToRem(32)};
  }
`;

const SelectDropDownWrapperMobile = styled.article<{ reduceWidth?: boolean; addLeftMargin?: boolean }>`
  position: relative;
 // margin-left: ${(props) => (props.addLeftMargin ? `${pxToRem(16)}` : '0')};
  //max-width: ${(props) => (props.reduceWidth ? `90%` : 'auto')};
  width:300px;
  margin-left: 20px;
  margin-bottom: ${pxToRem(12)};
  ${up('md')} {
    //margin-left: 0;
    max-width: ${pxToRem(320)};
    padding-right: ${pxToRem(32)};
  }
`;

const SelectDropdownContainer = styled.div`

  margin-top: ${pxToRem(-22)};
  ${up('md')}{
    margin-top: 0.2rem;
    margin-left: 25px;

  }}
`;

const SelectDropdownContainerMobile = styled.div`

  margin-top: 0.5rem;
  ${up('md')}{
    margin-top: 0.2rem;
    margin-left: 25px;

  }}
`;

const SelectDropdownLabel = styled(P2)`
  //margin-top: 6px;
  position: relative;
  top: 1.6rem;
  margin-left: 25px;
  font-weight:700;
`;

const SelectDropdownLabelMobile = styled(P2)`
  //margin-top: 6px;
  position: relative;
  top: 1.6rem;
 // margin-left: 20px;
 font-weight:700;
`;

const TooltipHeading = styled(B1)`
  color: #4a4a4a;
  padding-bottom: 16px;
  ${up('md')} {
    padding-bottom: 6px;
  }
`;
const TooltipSubHeading = styled(P2)`
  color: ${(props) => props.theme.palette.grey2};
`;

const TooltipWrapper = styled.div`
  position: absolute;
  left: ${pxToRem(130)};
  bottom: ${pxToRem(42)};
  z-index: 0;
  .tooltipStyle {
    box-shadow: 0 ${pxToRem(2)} ${pxToRem(20)} #ed116429;
    border: 0;
    border-radius: ${pxToRem(6)};
    margin-left: -8px;
    ${up('md')} {
      width: ${pxToRem(380)};
    }
  }
  ${up('md')} {
    left: ${pxToRem(160)};
    bottom: ${pxToRem(52)};
  }
`;

const ToolTipIcon = styled.div`
  margin-left: 90px;
`;

const ToolTipIconMobile = styled.div`
  margin-left: 60px;
`;

 const WhiteChevron = styled(ChevronRightWhite)`
 `;

 const ChevronWrapper = styled.div`
  margin-left: 900px;
  margin-top: -15px;
`;


const ChevronWrapperMobile = styled.div`
display: flex;
  justify-content: flex-end;
   //margin-left: 290px;
   margin-top: -18px;
`;

const ChevronRightBlackStyled = styled(ChevronRightBlack)<{ faq?: boolean; isOpen: boolean; enable: boolean }>`
  transition-duration: 0.8s;
  transform: ${(props) => (props.$isOpen ? 'rotate(-90deg)' : 'rotate(90deg)')};
  // ${up('md')} {
  //   display: ${(props) => (props.$faq && props.$enable ? '' : 'none')};
  // }
`;